import { HomeRole, homeUrlForRole } from "utils/urls";

export const getDefaultHomeRole = (availableRoles: HomeRole[]) => {
  for (const role of [HomeRole.ADMIN, HomeRole.INSTRUCTOR, HomeRole.SECTION_ASSISTANT]) {
    if (availableRoles.includes(role)) return role;
  }

  return HomeRole.STUDENT;
};

/** Role segment from `/home/<role>`, or null on bare `/home` / unrelated paths. */
export const getHomeRoleFromPath = (pathname: string): HomeRole | null =>
  (Object.values(HomeRole) as HomeRole[]).find((role) =>
    pathname.startsWith(homeUrlForRole(role)),
  ) ?? null;

/**
 * Persona for the current URL.
 * - null off `/home/<role>` (bare `/home`, section routes, etc.)
 * - while enrollments are pending, trust the path role so RoleSelect / HomeFooter
 *   don't flash a default/unknown persona
 * - after hydrate, student fallback if the path role isn't available
 */
export const resolveHomeRole = (
  pathRole: HomeRole | null,
  availableRoles: HomeRole[],
  isHomeRolesPending: boolean,
): HomeRole | null => {
  if (!pathRole) {
    return null;
  }
  if (isHomeRolesPending) {
    return pathRole;
  }
  return availableRoles.includes(pathRole) ? pathRole : HomeRole.STUDENT;
};
